export default "__VITE_ASSET__CSZcWRVq__"